import { Box, Grid, Typography } from '@mui/material'
import React, { useContext } from 'react'

import LocationOnIcon from '@mui/icons-material/LocationOn';
import defaultWATemplateImg from "../../../../assets/images/messageFormats/defaultWATemplateImage.png";

import styles from './../../../../assets/styles/componentStyles/chatLogsStyles/chatLogsTemplatePreview.module.scss'
import whatsappPreviewStyles from './../../../../assets/styles/componentStyles/templateLibraryStyles/whatsappTemplatePreview.module.scss'

import { WorkflowContext, WorkflowContextPayload } from '../../../../context/workflowContext';
import { onClickOfFlowButton, replacingTemplateMarkdownText } from '../../../../utils/constants';
import { isSendOrderDetailTemplateActionType } from '../../../dashboard/flowBuilder/utilityFunctions';
import { isMediaHeaderInTemplate } from '../../../dashboard/flowBuilder/flowBuilderConstants';
import { subButtonTypeIconMap } from '../../../dashboard/templatelibrary/constant';
import { isTemplateTypeCallPermissionRequest, shouldRenderBtnIcon } from '../../../dashboard/channels/global/whatsapp/templates/utils';
import { chatbotIntegratedChannelDeploymentObj } from '../../../../models/axiosModel';
import CallPermissionRequestPreview from '../../../dashboard/templatelibrary/WhatsAppTemplatePreview/CallPermissionRequestPreview';

interface workFlowPreviewInterface {
    flagWorkFlow: boolean,
    actionData?: any,
    messageTemplateDetail: any, 
    stepAction: any,
}

const WorkflowTemplatePreview = (props: workFlowPreviewInterface) => {
    const { flagWorkFlow, actionData, stepAction, messageTemplateDetail } = props;
    const [open, setOpen] = React.useState(false);

    const { currentActiveStaticWorkflow } = useContext(WorkflowContext) as WorkflowContextPayload
    //@ts-ignore
    // let messageTemplateDetail = currentActiveStaticWorkflow?.additional_data?.whatsapp_templates?.find((template) => Number(template.whatsapp_template_id) == Number(actionData?.whatsapp_template.whatsapp_template_id))

    const toggleDrawer1 = (newOpen: any) => () => {
        setOpen(newOpen);
    };

    const isCallPermissionRequest = isTemplateTypeCallPermissionRequest(messageTemplateDetail?.whatsapp_template_type?.name);
    const wabaName = (currentActiveStaticWorkflow?.chatbot_integrated_channel_deployment?.integrated_channel_data?.[0] as chatbotIntegratedChannelDeploymentObj | undefined)?.waba_name || "WhatsApp Business";

    function replaceWithSpanTags(bodyText: string) {
        let result = bodyText;
        if (actionData?.action_send_dm_wa_template_variable_data?.length > 0) {

            // Iterate through each variable mapping from action
            actionData.action_send_dm_wa_template_variable_data.forEach((variable: any) => {
                // @ts-ignore
                let variableKeyToReplace: any = messageTemplateDetail?.whatsapp_template_data?.[0]?.whatsapp_template_body?.whatsapp_template_body_variable_data.find((variable1: any) => Number(variable1.whatsapp_template_dynamic_variable_id) == Number(variable.whatsapp_template_dynamic_variable_id))?.whatsapp_template_dynamic_variable_key
                const variableKey = variableKeyToReplace
                let variableName = "";
                if (variableKey) {
                    if (variable?.chatbot_custom_variable_configuration) {
                        variableName = `{{${variable?.chatbot_custom_variable_configuration?.chatbot_custom_variable_name}}}`
                    } else if (variable?.fallback_value) {
                        variableName = variable.fallback_value
                    } else {
                        // @ts-ignore
                        variableName = messageTemplateDetail?.whatsapp_template_data[0]?.whatsapp_template_body?.whatsapp_template_body_variable_data?.find((vari) => String(vari?.whatsapp_template_dynamic_variable_id) == String(variable?.whatsapp_template_dynamic_variable_id))?.whatsapp_template_dynamic_variable_key;
                    }
                    // Create a span tag with a style, you can modify the style as needed
                    const spanTag = `<span style="color: blue; font-weight: bold;">${variableName}</span>`;
                    // Replace the placeholder with the span tag
                    result = result.replace(variableKey, spanTag);
                }
            });
        }

        result = result.replace(/\*(.*?)\*/g, '<b>$1</b>');  // Bold
        result = result.replace(/\\n/g, '<br>');

        return result;
    }

    function replaceWithSpanTagsHeader(bodyText: string) {
        let result = bodyText;
        if (actionData?.action_send_dm_wa_template_variable_data?.length > 0) {

            // Iterate through each variable mapping from action
            actionData.action_send_dm_wa_template_variable_data.forEach((variable: any) => {
                // @ts-ignore
                let variableKeyToReplace: any = messageTemplateDetail?.whatsapp_template_data?.[0]?.whatsapp_template_header?.whatsapp_template_header_data[0]?.whatsapp_template_header_variable_data.find((variable1: any) => Number(variable1.whatsapp_template_dynamic_variable_id) == Number(variable.whatsapp_template_dynamic_variable_id))?.whatsapp_template_dynamic_variable_key
                const variableKey = variableKeyToReplace
                let variableName = "";
                if (variableKey) {
                    if (variable?.chatbot_custom_variable_configuration) {
                        variableName = `{{${variable?.chatbot_custom_variable_configuration?.chatbot_custom_variable_name}}}`
                    } else if (variable?.fallback_value) {
                        variableName = variable.fallback_value
                    } else {
                        // @ts-ignore
                        variableName = variableKeyToReplace
                    }
                    // Create a span tag with a style, you can modify the style as needed
                    const spanTag = `<span style="color: blue; font-weight: bold;">${variableName}</span>`;
                    // Replace the placeholder with the span tag
                    result = result.replace(variableKey, spanTag);
                }
            });
        }

        result = result.replace(/\*(.*?)\*/g, '<b>$1</b>');  // Bold
        result = result.replace(/\\n/g, '<br>');

        return result;
    }

    const getLocationHeaderField = (variableKey: string) => {
        const fieldId = messageTemplateDetail?.whatsapp_template_data?.[0]?.whatsapp_template_header?.whatsapp_template_header_data[0]?.whatsapp_template_header_variable_data?.find((variable: any) => variable?.whatsapp_template_dynamic_variable_key?.toLowerCase() === variableKey?.toLowerCase())?.whatsapp_template_dynamic_variable_id;
        if(fieldId){
            const headerField = actionData?.action_send_dm_wa_template_variable_data?.find((variable: any) => String(variable?.whatsapp_template_dynamic_variable_id) === String(fieldId));
    
            if(headerField) {
                let fieldVariableKey = variableKey;
    
                if(headerField?.chatbot_custom_variable_configuration) {
                    fieldVariableKey = `{{${headerField?.chatbot_custom_variable_configuration?.chatbot_custom_variable_name}}}`;
                } else if(headerField?.fallback_value) {
                    fieldVariableKey = headerField?.fallback_value;
                }
    
                return <span 
                        style={{ color: "blue", fontWeight: "bold" }}
                    >
                        {fieldVariableKey}
                    </span>;
            }
        }
        return <></>;
    }

    const messageText = (type: string) => {
        let template: string = "";

        if (type?.toLowerCase() === "body") {
            return replaceWithSpanTags(messageTemplateDetail?.whatsapp_template_data?.[0].whatsapp_template_body?.whatsapp_template_body_value || "-")
        }

        else if (type?.toLowerCase() === "header") {
            // template = messageTemplateDetail?.whatsapp_template_data?.[0].whatsapp_template_header?.whatsapp_template_header_data?.[0]?.whatsapp_template_header_data_value || "-"
            return replaceWithSpanTagsHeader(messageTemplateDetail?.whatsapp_template_data?.[0].whatsapp_template_header?.whatsapp_template_header_data?.[0]?.whatsapp_template_header_data_value || "-")
        }

        else {
            template = messageTemplateDetail?.whatsapp_template_data?.[0].whatsapp_template_footer?.whatsapp_template_footer_value || "-"
        }

        return replacingTemplateMarkdownText(template);
    }

    const getSubButtonText = (subBtnData: any) => {
        let fieldVal = subBtnData?.whatsapp_template_button_sub_type_field_data?.filter((field: any) => field.field_name == "Button Text")[0]
        return fieldVal?.whatsapp_template_button_sub_type_field_value
    }

    function getHeaderMedia() {
        if (messageTemplateDetail) {
            // @ts-ignore
            let actionVarConfig = actionData?.action_send_dm_wa_template_variable_data?.find((variable: any) => Number(variable?.whatsapp_template_dynamic_variable_id) == Number(messageTemplateDetail.whatsapp_template_data[0].whatsapp_template_header.whatsapp_template_header_data[0].whatsapp_template_header_variable_data[0]?.whatsapp_template_dynamic_variable_id))
            if (actionVarConfig?.chatbot_custom_variable_configuration) {
                return actionVarConfig?.chatbot_custom_variable_configuration?.chatbot_custom_variable_fallback_value
            } else if (actionVarConfig?.fallback_value) {
                return actionVarConfig.fallback_value
            } else {
                // @ts-ignore
                return messageTemplateDetail?.whatsapp_template_data[0]?.whatsapp_template_header?.whatsapp_template_header_data[0]?.whatsapp_template_header_variable_data[0]?.whatsapp_template_dynamic_variable_sample_value || defaultWATemplateImg
            }
        }
    }

    const renderHeader = () => {
        const headerType = messageTemplateDetail?.whatsapp_template_data?.[0].whatsapp_template_header?.whatsapp_template_header_type_name?.toLowerCase();
        switch(headerType) {
            case 'image':
                return (
                    <Grid item sx={{ overflow: "hidden" }}>
                        <img alt=";php" src={getHeaderMedia()}
                            // src={messageTemplateDetail?.whatsapp_template_data?.[0].whatsapp_template_header?.whatsapp_template_header_data?.[0]?.whatsapp_template_header_data_value || defaultWATemplateImg} 
                            className={styles.templatePreviewHeaderImage} />
                    </Grid>
                )
            case 'video':
                return (
                    <Grid item>
                        <video key={getHeaderMedia()} style={{ width: "100%", maxHeight: "200px" }} controls className='video-tag'>
                            {/* <source src={messageTemplateDetail?.whatsapp_template_data?.[0].whatsapp_template_header?.whatsapp_template_header_data?.[0]?.whatsapp_template_header_data_value} type="video/mp4" /> */}
                            <source src={getHeaderMedia() ?? ''} type="video/mp4" />
                        </video>
                    </Grid>
                );
            case 'text':
                return (
                    <Grid item className={styles.templatePrviewHeaderItem}>
                        <pre
                            className={styles.preTextStyle}
                            dangerouslySetInnerHTML={{ __html: messageText("header") }}
                        />
                    </Grid>
                );
            case 'location':
                return (
                    <>
                        <Box className={whatsappPreviewStyles.whatsappPreview__locationHeader}>
                            <Box className={whatsappPreviewStyles.whatsappPreview__locationHeaderMap}>
                                <LocationOnIcon className={whatsappPreviewStyles.whatsappPreview__locationHeaderMapIcon} />
                            </Box>
                            <Box className={whatsappPreviewStyles.whatsappPreview__locationHeaderFields}>
                                <Box className={`${whatsappPreviewStyles.whatsappPreview__locationHeaderField} ${whatsappPreviewStyles["whatsappPreview__locationHeaderField--name"]}`}>
                                    <Typography className={whatsappPreviewStyles.whatsappPreview__locationHeaderNameText}>
                                        {getLocationHeaderField("{{name}}")}
                                    </Typography>
                                </Box>

                                <Box className={whatsappPreviewStyles.whatsappPreview__locationHeaderField}>
                                    <Typography className={whatsappPreviewStyles.whatsappPreview__locationHeaderAddressText}>
                                        {getLocationHeaderField("{{address}}")}
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>
                    </>
                );
            default: 
                return null;
        }
    }
    
    return (
        <>
            {messageTemplateDetail &&
                <>
                    <Grid item padding={"0px"} className={`${styles.previewSectionCardBlock} ${styles.workflowPreviewSectionCardBlock}`} sx={{ margin: flagWorkFlow ? "0 auto !important" : "", borderRadius: !flagWorkFlow ? "5px 5px 0px 0px !important" : "" }}>
                        <Grid container direction={"column"} gap={"4px"}>
                            {renderHeader()}
                            <Grid item className={`${isMediaHeaderInTemplate(messageTemplateDetail?.whatsapp_template_data?.[0].whatsapp_template_header?.whatsapp_template_header_type_name) ?  styles.templatePrviewBodyItem : styles.templatePrviewBodyItemWithMediaHeader}`} mb={"4px"}>
                                <pre
                                    className={styles.preTextStyle}
                                    dangerouslySetInnerHTML={{ __html: messageText("body") }}
                                />
                            </Grid>
                            {messageTemplateDetail?.whatsapp_template_data?.[0].whatsapp_template_footer?.whatsapp_template_footer_value && messageTemplateDetail?.whatsapp_template_data?.[0].whatsapp_template_footer?.whatsapp_template_footer_value?.length > 0 &&
                                <Grid item className={styles.templatePrviewFooterItem}>
                                    <pre
                                        className={styles.preTextStyle}
                                        dangerouslySetInnerHTML={{ __html: messageText("footer") }}
                                    />
                                </Grid>
                            }
                            {/* {flagWorkFlow &&
                                messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_button?.length > 3 && messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_button?.sort((button1: any, button2: any) => button1.whatsapp_template_button_index - button2.whatsapp_template_button_index)?.map((btnData: any) => {
                                    return <>
                                        <Grid item paddingBlock={"10px"} className={`${styles.templatePreviewButtonItem} ${styles.templatePreviewButtonItemBorder}`}>
                                            <Grid container justifyContent={"center"} gap={1} alignItems={"center"}>
                                                <Grid item>
                                                    {getSubButtonIcon(btnData.whatsapp_template_button_type_id)}
                                                </Grid>
                                                <Grid item>
                                                    {getSubButtonText(btnData)}
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </>
                                })
                            } */}
                        </Grid> 

                        {isSendOrderDetailTemplateActionType(stepAction?.action_type?.action_type_name) && // Only for Send Order Detail Template
                            <Grid item paddingBlock={"10px"} className={`${styles.templatePreviewButtonItem} ${styles.templatePreviewButtonItemBorder}`}>
                                <Grid container justifyContent={"center"} gap={1} alignItems={"center"}>
                                    <Grid item>
                                        {"Review and Pay"}
                                    </Grid>
                                </Grid>
                            </Grid>
                        }

                        {
                            messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_button?.length > 0 && messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_button.flatMap((btn: any) => btn.whatsapp_template_button_data).map((subBtnData: any, ind: number) => {
                                return <Grid item key={ind} paddingBlock={"10px"} className={`${styles.templatePreviewButtonItem} ${styles.templatePreviewButtonItemBorder}`} onClick={() => onClickOfFlowButton(subBtnData, messageTemplateDetail?.meta_integration_whatsapp_id)}>
                                    <Grid container justifyContent={"center"} gap={1} alignItems={"center"}>
                                        {shouldRenderBtnIcon(messageTemplateDetail, subBtnData?.whatsapp_template_button_sub_type_name) &&
                                            <Grid item>
                                                {subButtonTypeIconMap[subBtnData?.whatsapp_template_button_sub_type_name?.toLowerCase() as keyof typeof subButtonTypeIconMap]}
                                            </Grid>
                                        }
                                        <Grid item>
                                            {getSubButtonText(subBtnData)}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            })
                        }

                    </Grid>

                    {/* Call Permission Template Button */}
                    {isCallPermissionRequest && (
                        <Grid item className={styles.workflowCallPermissionPreview}>
                            <CallPermissionRequestPreview wabaName={wabaName} fullWidth variant="primary" />
                        </Grid>
                    )}
                </>
            }
        </>
    )
}

export default WorkflowTemplatePreview